/**
 * BEM suffix classes for `.paid-media-mini-tag` — platform / channel / role styling
 * (Meta + Google Ads paid media dashboards).
 */

const norm = (s: string) => s.trim().toLowerCase().replace(/[\s-]+/g, "_");

/** Meta / audience network platform pill (slug or display label). */
export function paidMediaMetaPlatformChannelClass(
  platformKeyOrLabel: string | undefined | null
): string {
  const k = norm(platformKeyOrLabel ?? "");
  if (!k) {
    return "paid-media-mini-tag--channel-default";
  }
  if (k.includes("instagram")) {
    return "paid-media-mini-tag--channel-instagram";
  }
  if (k.includes("facebook") && !k.includes("audience")) {
    return "paid-media-mini-tag--channel-facebook";
  }
  if (k.includes("audience") && k.includes("network")) {
    return "paid-media-mini-tag--channel-audience-network";
  }
  if (k.includes("messenger")) {
    return "paid-media-mini-tag--channel-messenger";
  }
  if (k.includes("threads")) {
    return "paid-media-mini-tag--channel-threads";
  }
  return "paid-media-mini-tag--channel-default";
}

/** Google Ads ad network type from API (e.g. SEARCH, YOUTUBE). */
export function googleAdsAdNetworkChannelClass(adType: string | undefined | null): string {
  const t = (adType ?? "UNKNOWN").toUpperCase().replace(/\s+/g, "_");
  const map: Record<string, string> = {
    SEARCH: "paid-media-mini-tag--channel-g-search",
    SEARCH_PARTNERS: "paid-media-mini-tag--channel-g-search-partners",
    PERFORMANCE_MAX: "paid-media-mini-tag--channel-g-pmax",
    SHOPPING: "paid-media-mini-tag--channel-g-shopping",
    DISCOVERY: "paid-media-mini-tag--channel-g-discover",
    DISCOVER: "paid-media-mini-tag--channel-g-discover",
    GMAIL: "paid-media-mini-tag--channel-g-gmail",
    YOUTUBE: "paid-media-mini-tag--channel-g-youtube",
    VIDEO: "paid-media-mini-tag--channel-g-youtube",
    CONTENT: "paid-media-mini-tag--channel-g-content",
    DISPLAY: "paid-media-mini-tag--channel-g-display",
    SMART: "paid-media-mini-tag--channel-g-smart",
    LOCAL: "paid-media-mini-tag--channel-g-local",
    APP: "paid-media-mini-tag--channel-g-app",
  };
  return map[t] ?? "paid-media-mini-tag--channel-g-other";
}

/** Inferred channel from Google Ads campaign name (mock / heuristic labels). */
export function googleAdsCampaignNameChannelClass(campaignName: string): string {
  const n = campaignName.toLowerCase();
  if (n.includes("search")) {
    return "paid-media-mini-tag--channel-g-search";
  }
  if (n.includes("display")) {
    return "paid-media-mini-tag--channel-g-display";
  }
  if (n.includes("shopping")) {
    return "paid-media-mini-tag--channel-g-shopping";
  }
  if (n.includes("video")) {
    return "paid-media-mini-tag--channel-g-youtube";
  }
  if (n.includes("performance max") || n.includes("pmax")) {
    return "paid-media-mini-tag--channel-g-pmax";
  }
  return "paid-media-mini-tag--channel-g-other";
}

export const PAID_MEDIA_TAG_ROLE_CAMPAIGN = "paid-media-mini-tag--role-campaign";
export const PAID_MEDIA_TAG_ROLE_ADSET = "paid-media-mini-tag--role-adset";
/** Post / creative type (Meta ads). */
export const PAID_MEDIA_TAG_META_POST_TYPE = "paid-media-mini-tag--meta-post-type";
